module.exports = __webpack_public_path__ + "static/media/image04.baa2404d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/image04.jpg
// module id = 316
// module chunks = 0